import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";
import { JwtInterceptor } from "./interceptors/jwt.interceptor";
import { ReactiveFormsModule } from "@angular/forms";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoginComponentComponent } from "./login-component/login-component.component";
import { HomeComponent } from "./home/home.component";
import { MainNavComponent } from "./main-nav/main-nav.component";
import { LayoutModule } from "@angular/cdk/layout";
import { PaymentInitiateComponent } from "./payment/payment-initiate/payment-initiate.component";
import { RefundRequestComponent } from "./refund/refund-request/refund-request.component";
import { RefundApprovedComponent } from "./refund/refund-approved/refund-approved.component";
import { RefundInitiateComponent } from "./refund/refund-initiate/refund-initiate.component";
import { RefundSuccessComponent } from "./refund/refund-success/refund-success.component";
import { RefundFailedComponent } from "./refund/refund-failed/refund-failed.component";
import { MaterialModule } from "./material.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";

import { ReasonComponent } from "./reason/reason.component";
import { PaymentDetailsComponent } from "./payment/payment-initiate/payment-details/payment-details.component";
import { PaymentNROComponent } from "./payment/payment-nro/payment-nro.component";
import { PayementBlockerComponent } from './payement-blocker/payement-blocker.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponentComponent,
    HomeComponent,
    MainNavComponent,
    // PaymentFailedComponent,
    PaymentInitiateComponent,
    // PaymentSuccessComponent,
    RefundRequestComponent,
    RefundApprovedComponent,
    RefundInitiateComponent,
    RefundSuccessComponent,
    RefundFailedComponent,
    ReasonComponent,
    PaymentDetailsComponent,
    PaymentNROComponent,
    PayementBlockerComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-right",
      preventDuplicates: true,
      maxOpened: 1,
      newestOnTop: true,
      autoDismiss: false,
    }),
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    NgbModule,
  ],
  entryComponents: [ReasonComponent, PaymentDetailsComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
